
    <div class="firmware-generic-logical-widget" *ngIf="entity">
      [Firmware Logical - Generic]}
    </div>

